<template>
  <a-modal
    title="稿件信息"
    :visible="visible"
    width="1200px"
    :dialog-style="{ top: '30px' }"
    @cancel="() => (this.visible = false)"
    :destroyOnClose="true"
    :footer="null"
    :maskClosable="false"
  >
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="基本信息" key="1">
        <a-row class="info_row">
          <a-col :span="3" class="man_title">标题：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.cnTitle }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">副标题：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.subtitle }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">摘要：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.summary }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">关键词：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.keyWords }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">课题信息：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.subjectInfo }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">参考文献：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.referencesInfo }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">版本：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.sectionInfo }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">学科：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.discipline }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">字数：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.wordCount }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">备注：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ manuscript.note }}</label>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane tab="作者信息" key="2" forceRender>
        <template>
          <a-table
            :pagination="false"
            :columns="authorColumns"
            :dataSource="authorData"
            :rowKey="(record) => record.authorSort"
            bordered
          >
            <span slot="corAuthor" slot-scope="text, record">
              <a-checkbox
                v-if="record.corAuthor == 1"
                :checked="true"
                disabled
              ></a-checkbox>
              <a-checkbox v-if="record.corAuthor == 0" disabled></a-checkbox>
            </span>
            <span slot="sex" slot-scope="text, record">
              <label v-if="record.sex == 0">女</label>
              <label v-if="record.sex == 1">男</label>
            </span>
          </a-table>
        </template>
      </a-tab-pane>
      <a-tab-pane tab="银行卡信息" key="3">
        <a-row class="info_row">
          <a-col :span="3" class="man_title">开户行：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ bankCard.openBank }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">开户行号：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ bankCard.bankCode }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">银行卡号：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ bankCard.bankCard }}</label>
          </a-col>
        </a-row>
        <a-row class="info_row">
          <a-col :span="3" class="man_title">身份证号：</a-col>
          <a-col :span="20" class="label_top">
            <label>{{ bankCard.idCard }}</label>
          </a-col>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import qs from "qs";
export default {
  name: "ManuscriptInfo",
  props: {
    infoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      manuscript: {},
      authorColumns: [
        {
          title: "作者顺序",
          dataIndex: "sort",
          width: 90,
        },
        {
          title: "通讯作者",
          dataIndex: "corAuthor",
          width: 90,
          scopedSlots: { customRender: "corAuthor" },
        },
        {
          title: "姓名",
          dataIndex: "authorName",
          width: 90,
        },
        {
          title: "性别",
          dataIndex: "sex",
          width: 80,
          scopedSlots: { customRender: "sex" },
        },
        {
          title: "出生年月",
          dataIndex: "birth",
          width: 100,
        },
        {
          title: "单位名称",
          dataIndex: "companyName",
        },
        {
          title: "单位地址",
          dataIndex: "companyAddress",
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          width: 120,
        },
        {
          title: "Email",
          dataIndex: "email",
        },
      ],
      authorData: [],
      bankCard: {},
    };
  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.manuscript = { ...this.infoData };
        this.visible = true;
        this.manuscriptsInfo();
      });
    },
    manuscriptsInfo() {
      this.axios
        .get("/manuscriptsAuthor/queryManuscriptsAuthor", {
          params: {
            code: this.manuscript.code,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.authorData = res.data.data;
            var n = 1;
            for (var i = 0; i < this.authorData.length; i++) {
              this.authorData[i].sort = "第" + n + "作者";
              n += 1;
            }
          } else {
            this.utils.messageInfo(this, "error", "查询作者信息失败！");
          }
        });
      this.axios
        .get("/manuscripts/queryAuthorBankCard", {
          params: {
            bankCardId: this.manuscript.bankCardId,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.bankCard = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询银行卡信息失败！");
          }
        });
    },
  },
};
</script>
<style>
@import "../../assets/css/PageCss.css";
</style>
<style scoped>
.info_row {
  margin-top: 8px;
}
</style>